// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export var FrameType;
(function (FrameType) {
    FrameType["DOCUMENT"] = "DOCUMENT";
    FrameType["CANVAS"] = "CANVAS";
    FrameType["COMPONENT_SET"] = "COMPONENT_SET";
    FrameType["COMPONENT_VARIANT"] = "COMPONENT_VARIANT";
    FrameType["COMPONENT"] = "COMPONENT";
    FrameType["SECTION"] = "SECTION";
    FrameType["FRAME"] = "FRAME";
})(FrameType || (FrameType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class FigmaFrame {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.type = model.type;
        this.children = model.children.map((child) => new FigmaFrame(child));
    }
}
